export default __webpack_public_path__ + "static/media/bg.8a4166e5.svg";